import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Stack,
    Typography
} from "@mui/material";

import {
    Timeline,
    TimelineConnector,
    TimelineContent,
    TimelineDot,
    TimelineItem,
    TimelineOppositeContent,
    TimelineSeparator
} from "@mui/lab";

import DoNotDisturbAltIcon from '@mui/icons-material/DoNotDisturbAlt';
import { 
    FaClock, 
    FaCircleCheck
} from "react-icons/fa6";

import {
    PiClockCountdownFill 
} from "react-icons/pi";

import { MdChangeCircle } from "react-icons/md";

import { colors } from "../../../utils/colors";

export const HistoricoModal = ({ data = {}, setOpenHistorico}) => {

    // * DESESTRUCTURACION DE LA DATA.
    const {
        open = false,
        historico = []
    } = data;

    // * COMPONENTE PERSONALIZADO PARA DETERMINAR LOS ICONOS SEGUN EL ESTADO.
    const IconEstatus = ({ estado = "" }) => {

        // * REMOVER ESPACIOS.
        const estadoNormalized = estado.replace(/\s/g, '');

        const iconos = {
            Pendiente: FaClock,
            Aplazado: PiClockCountdownFill,
            Completado: FaCircleCheck,
            Enproceso: MdChangeCircle 
        };

        const IconSeleccionado = iconos[estadoNormalized];

        return <IconSeleccionado />;
    }

    return (
        <Dialog
            PaperProps={{ sx: { width: "45%", height: `${45 + (3 * historico.length)}%` } }}
            open={open}
            maxWidth='lg'
        >
            <DialogTitle sx={{textTransform: 'uppercase'}} className='text-mem text-center'>Historial</DialogTitle>
            <Divider  sx={{ color: colors.azulMem }} />

            <DialogContent>
                <Stack mt={2}>
                    <Timeline position="alternate">
                        {
                            historico.map((item, index) => (
                                <TimelineItem key={index}>
                                    <TimelineOppositeContent
                                        sx={{ m: 'auto 0' }}
                                        align="right"
                                        variant="body2"
                                        color={colors.azulMem}
                                    >
                                        {item.hora}
                                    </TimelineOppositeContent>
                                    <TimelineSeparator >
                                        <TimelineConnector />
                                            <TimelineDot sx={{color: '#eeeeee', backgroundColor: colors.azulMem}}>
                                                <IconEstatus estado={item.estado.descripcion}  /> 
                                            </TimelineDot>
                                        <TimelineConnector />
                                    </TimelineSeparator>
                                    <TimelineContent sx={{ py: '12px', px: 2 }}>
                                        <Typography variant="h6" component="span">
                                            {item.estado.descripcion}
                                        </Typography>
                                        <Typography fontSize={14}><b>Observaciones:</b> {item.observaciones}</Typography>
                                        <Typography fontSize={14}><b>Modificado por:</b> {item.nombreUsuarioModificado}</Typography>
                                        <Typography fontSize={14}><b>Mensajero:</b> {item.nombreMensajero}</Typography>
                                    </TimelineContent>
                                </TimelineItem>
                            ))
                        }
                    </Timeline>
                </Stack>
            </DialogContent>

            <Divider />
            <DialogActions className='justify-content-center'>
                <button id='btn-cancelar' type='button' onClick={() => setOpenHistorico({ open: false, historico: []})} className='btn btn-danger'><DoNotDisturbAltIcon sx={{marginTop: -0.5, marginRight: 0.5}}/>CANCELAR</button>
            </DialogActions>
                
        </Dialog>
    )
}
